/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/enforcement/commissioners_findings/files/r22_18947_c.pdf'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/enforcement/case_notes/casenotes_2.php?id=2021DB04&content_type=&content_nature=&msg_id2=539'
          );
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/enforcement/case_notes/casenotes_2.php?id=2016DB02&content_type=&content_nature=&msg_id2=541'
          );
        }}
        className="source3"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/enforcement/commissioners_findings/files/r22_18947_c.pdf'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/enforcement/case_notes/casenotes_2.php?id=2021DB04&content_type=&content_nature=&msg_id2=539'
          );
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/enforcement/case_notes/casenotes_2.php?id=2016DB02&content_type=&content_nature=&msg_id2=541'
          );
        }}
        className="source3"
      />
    </div>
  </>
);

export default Components004;
